import React, { useEffect, useState, useRef } from 'react'

import cx from 'classnames';
import Fonts from '../../../../fonts';
import { InputGroup, Form, Button } from 'react-bootstrap';

import Content from '../../../../widgets/core/content';
import { CONTENT } from '../../../../../constants/widgetTypes';

import { useParentWidgetSelectorForType } from '../../../../widgets/core/hooks';
import { getBoxShadow } from '../../../../../services/cssHelper.service';
import { getColorsConfig } from '../../../../../components/AssetViewer/helper/cssHelper';

import styles from './searchBox.module.scss';
import { injectAktivFallback } from '../../../../widgets/widget.helper';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';


const SearchComponent = ({ className, widgetProps, breakpoint, parentProps }) => {
  const contentContext = React.useContext(Content.Context);
  const id = get(widgetProps, 'uid');

  const properties = get(widgetProps, 'properties', {});
  const [value, setValue] = useState('');
  const placeholder = get(widgetProps, 'properties.desktop.placeholder') || "";
  const searchIconColor = getColorStyles(get(widgetProps, 'properties.desktop.searchIconColor'))
  const contentWidget = useParentWidgetSelectorForType(widgetProps.uid, CONTENT);
  const itemsPerPage = get(contentWidget, 'properties.desktop.layoutStyle.itemsPerPage', 3);

  var inputWrapperStyles = getInputWrapperStyles(properties);
  var placeholderStyle = getPlaceholderStyle(properties);
  var inputFieldStyle = getInputFieldStyles(properties);

  const handleSearchOnChange =(e)=> {
    setValue(e.target.value);
    contentContext.updateQueryInContenGrid(contentWidget.uid, e.target.value)
    if (isEmpty(e.target.value)) {
      executeSearchAsset()
    }
  }

  const executeSearchAsset =()=> {
    if(contentWidget.uid) {
      contentContext.fetchMappingsForContentGrid(contentWidget.uid, 0, itemsPerPage);
    }
  }

  return (
    <InputGroup style={inputWrapperStyles} className={cx(styles.assetSearchBox, className)}>
      {placeholderStyle &&
        <style>
          {`
            #${id} input::-webkit-input-placeholder {
              color: ${placeholderStyle.color};
              font-family: ${placeholderStyle.fontFamily}
            }
          `}
        </style>
      }
      <i style={searchIconColor} className={cx('cleverstory-search', styles.searchIcon)} />
      <input type='text'
        placeholder={placeholder}
        style={inputFieldStyle}
        className={styles.inputField}
        value={value}
        onChange={handleSearchOnChange}
        onKeyPress={(event)=>{
          if (event.key === 'Enter') {
            contentContext.fetchMappingsForContentGrid(contentWidget.uid, 0, itemsPerPage)
          }
        }}
        disabled={false}
      />
      <SearchButtonWidget
        breakpoint={breakpoint}
        widgetProps={widgetProps}
        onClick={executeSearchAsset}
      />
    </InputGroup>
  )
}

const SearchButtonWidget = ({ breakpoint, widgetProps, onClick}) => {
  const [buttonStyles, setButtonStyles] = useState({});

  Fonts.useFont(get(widgetProps, 'fonts') || []);
  const properties = get(widgetProps, 'properties', {});

  useEffect(() => {
    updateButtonStyles('regular');
  }, [breakpoint, widgetProps]);

  const updateButtonStyles = (state) => {
    const updatedStyles = getButtonStyles(properties, state);
    setButtonStyles(updatedStyles);
  }

  return (
    <Button 
    className={styles.searchButton} 
    style={buttonStyles}
    variant="secondary" 
    id="search_button"
    onClick={onClick}
    onMouseOver={() => updateButtonStyles('hover')}
    onMouseOut={() => updateButtonStyles('regular')}
    >
      Search
    </Button>
  )
}


const searchComponentEquals = function (prevProps, nextProps) {
  const paths = ['className', 'widgetProps', 'breakpoint'];
  const next = pick(nextProps, paths);
  const previous = pick(prevProps, paths);

  const equals = isEqual(next, previous);
  return equals;
}


/**
 * --------------------------------------------------
 * Input Styles
 * -------------------------------------------------- 
*/

export function getInputFieldStyles(properties) {
  var inputstyles = {};

  if (!properties) {
    return inputstyles;
  }

  const defaultProperties = get(properties, `desktop`);

    const inputStyles = get(defaultProperties, 'font');
  const fontStyles = getFontStyle(inputStyles);

  inputstyles = {
    ...inputstyles,
    ...fontStyles
  }

  //font-color
  const colorRgb = get(defaultProperties, 'inputTextColor', null);
  const color = getColorStyles(colorRgb);
  inputstyles = {
    ...inputstyles,
    ...color
  }

  //font-family
  const fontFamily = get(defaultProperties, 'font.fontFamily', 'inherit');
  inputstyles = {
    ...inputstyles,
    fontFamily: injectAktivFallback(fontFamily)
  }

  //font-size
  const fontSizeString = get(defaultProperties, `font.fontSize`) || 14;
  if (fontSizeString) {
    var fontSize = parseInt(fontSizeString) + 'px';
    inputstyles['fontSize'] = fontSize;
  }

  return inputstyles;
}


function getInputWrapperStyles(properties) {
  var styles = {};

  if (!properties) {
    return styles;
  }

  const defaultProperties = get(properties, `desktop`);

  const inputPadding = get(defaultProperties, 'padding') || 0;

  if (inputPadding) {
    styles['padding'] = `0px ${inputPadding}px`;
  }

  const border = get(defaultProperties, 'border');
  const borderStyles = getBorderStyles(border);

  styles = {
    ...styles,
    ...borderStyles
  }

  //background-color
  const backgroundColorRgb = get(defaultProperties, 'background', null);
  if (backgroundColorRgb) {
    styles = {
      ...styles,
      background: getColorsConfig(backgroundColorRgb)
    }
  }

  return styles;
}

/**
 * --------------------------------------------------
 * Placeholder Styles
 * -------------------------------------------------- 
*/
export function getPlaceholderStyle(properties) {
  var styles = {};

  if (!properties) {
    return styles;
  }

  const defaultProperties = get(properties, `desktop`);
  const font = get(defaultProperties, 'font', {});


  const colorRgb = get(defaultProperties, 'placeholderColor', null);
  var color = 'inherit';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }

  var styles = {
    ...styles,
    color: color
  };


  //font-family
  const fontFamily = get(font, 'fontFamily');
  if (fontFamily) {
    styles = {
      ...styles,
      fontFamily: injectAktivFallback(fontFamily)
    }
  }

  return styles;
}

export function getColorStyles(value) {
  if (!value) {
    return null;
  }

  const colorRgb = value;

  var color = 'inherit';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }

  var styles = {
    ...styles,
    color: color
  };

  return styles;
}

export function getBorderStyles(border) {
  var styles = {};
  if (!border) {
    return styles;
  }

  const topLeft = get(border, 'radius.topLeft', null);
  const topRight = get(border, 'radius.topRight', null);
  const bottomLeft = get(border, 'radius.bottomLeft', null);
  const bottomRight = get(border, 'radius.bottomRight', null);

  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }

  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }

  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }

  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }

  const borderStyle = get(border, 'style') || 'all';
  if (borderStyle !== 'none') {
    const borderWidthString = get(border, 'width') || 0;
    var borderWidget = parseInt(borderWidthString) + 'px';

    const fieldName = borderStyle == 'all' ? 'borderWidth' : 'borderBottomWidth';
    styles[fieldName] = borderWidget;

    const colorRgb = get(border, 'color');
    var color = 'transparent';
    if (colorRgb) {
      color = getColorsConfig(colorRgb);
    }

    styles['borderColor'] = color;
  }

  return styles;
}

// button styles

function getButtonStyles(properties, active) {
  var styles = {};

  if (!properties) {
    return styles;
  }

  const defaultProperties = get(properties, `desktop`);
  const defaultStyles = get(defaultProperties, `buttonStyles.regular`, {});

  //font-color
  const colorRgb = get(defaultProperties, `buttonStyles.${active}.font.color`, null);
  const color = getColorStyles(colorRgb);
  styles = {
    ...styles,
    ...color
  }

  //background
  const backgroundRgb = get(defaultProperties, `buttonStyles.${active}.background`, null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = getColorsConfig(backgroundRgb);
  }

  styles['background'] = background;

  const font = get(defaultStyles, 'font', {});

  //font-family
  const fontFamily = get(font, 'fontFamily');
  if (fontFamily) {
    styles = {
      ...styles,
      fontFamily: injectAktivFallback(fontFamily)
    }
  }

  //font-size
  const fontSizeString = get(defaultProperties, 'buttonStyles.regular.font.fontSize', null);
  var fontSize = 'inherit'
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }

  styles['fontSize'] = fontSize;

  //line spacing
  const lineSpacingString = get(defaultProperties, 'buttonStyles.regular.font.lineSpacing', null);
  if (lineSpacingString) {
    const lineSpacing = parseFloat(lineSpacingString) + 'em';
    styles['lineHeight'] = lineSpacing;
  }

  //Letter Spacing
  const letterSpacingString = get(defaultProperties, 'buttonStyles.regular.font.letterSpacing', null);
  if (letterSpacingString) {
    const letterSpacing = parseFloat(letterSpacingString) + 'em';
    styles['letterSpacing'] = letterSpacing;
  }

  //font-style
  const bold = get(font, 'style.bold', false);
  if (bold) {
    styles['fontWeight'] = 'bold';
  }

  const italic = get(font, 'style.italic', false);
  if (italic) {
    styles['fontStyle'] = 'italic';
  }

  const underline = get(font, 'style.underline', false);
  if (underline) {
    styles['textDecoration'] = 'underline';
  }

  //border
  const border = get(defaultStyles, 'border', {});
  const borderColor = get(defaultProperties, `buttonStyles.${active}.border.color`, null);

  const borderStyle = getBorderStyles(border, borderColor);
  styles = {
    ...styles,
    ...borderStyle
  }

  //DropShadow
  const shadow = get(defaultProperties, `buttonStyles.${active}.shadow`, null);
  const shadowStyle = getBoxShadow(shadow);
  styles = {
    ...styles,
    ...shadowStyle
  }

  // //alignment
  // const alignment = get(deviceProperties, 'alignment', {});

  // var position = get(alignment, 'position', 'center');
  // styles['justifyContent'] = position;
  // styles['textAlign'] = position;

  // var margin = get(alignment, 'margin', 0);
  // if (position === 'left') {
  //   styles = {
  //     ...styles,
  //     paddingLeft: `${margin}px`
  //   }
  // } else if (position === 'right') {
  //   styles = {
  //     ...styles,
  //     paddingRight: `${margin}px`
  //   }
  // }

  return styles;
}

export function getFontStyle(fontStyles) {
  var styles = {};

  if (!fontStyles) {
    return styles;
  }

  //font-color
  const colorRgb = get(fontStyles, 'color', null);
  const color = getColorStyles(colorRgb);
  styles = {
    ...styles,
    ...color
  }

  //font-family
  const fontFamily = get(fontStyles, 'fontFamily', 'inherit');
  styles = {
    ...styles,
    fontFamily: injectAktivFallback(fontFamily)
  }

  //font-size
  const fontSizeString = get(fontStyles, `fontSize`) || 14;
  if (fontSizeString) {
    var fontSize = parseInt(fontSizeString) + 'px';
    styles['fontSize'] = fontSize;
  }

  return styles;
}

export const AssetSearchBox = React.memo(SearchComponent, searchComponentEquals);